import React from 'react'
import SearchInput from '../../../../../components/common/search-input/SearchInput'
import { SUBMISSION_SEARCH_PARAM } from '../../../../../constants/query-params'
import { useParams } from 'react-router'

const SubmissionSearch = () => {
    const { layerId: questionId } = useParams()
    const isAllQuestionsScreen = questionId === 'all'

    let label = 'Search by submission name'
    if (!isAllQuestionsScreen) label += ' or content'

    return <SearchInput placeholder={label} aria-label={label} searchParam={SUBMISSION_SEARCH_PARAM} />
}

export default SubmissionSearch
